import ReactPlayer from "react-player"
import { videoControls, videoPlayer, videoWrapper, onFlipping, suspiciousActivity } from "./styles"
import { Box, Button, Slider, CircularProgress, Stack } from "@mui/material"
import { PlayButton } from "./components/PlayButton"
import { PlayButtonArea } from "./components/PlayButtonArea"
import { useVideoPlayer, useVideoPlayerProps } from "./VideoPlayerModel"
import { SeekSlider } from "./components/SeekSlider"
import { FullScreenButton } from "./components/FullScreenButton"
import { FullScreen } from "react-full-screen"
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { SlidePlayer } from "./components/SlidePlayer"

export const VideoPlayer = (props: useVideoPlayerProps) => {

    const {
        url, muted, flipping, style, start, end,
        playerRef, screenHandle, playing, fullScreen, loadedSeconds, playedSeconds, duration,
        handlePlay, handlePlayArea, setPlaying, setMouseOver, handleChangeProgress, handleMoveProgress, reportChange, onReady
    } = useVideoPlayer(props)

    return !url?null:(
        <Box 
            sx={{...videoWrapper, ...style}} 
            onMouseOver={()=>{setMouseOver(true)}} onMouseLeave={()=>{setMouseOver(false)}}
        >
          <Box sx={{ ...videoWrapper, width: '100%', height: '100%' }}>
              <CircularProgress sx={{color: '#FFFFFF'}} size={'4rem'}/>
          </Box>

            <FullScreen handle={screenHandle} onChange={reportChange}>

              {url?.slice(-4) !== '.bin' && props?.faceProcessingServiceResult && (props.faceProcessingServiceResult?.target_found === false || props.faceProcessingServiceResult?.strangers_count > 0) && (
                  <Stack sx={suspiciousActivity}>
                    <ErrorOutlineOutlinedIcon sx={{ color: "#FFF" }} />
                    <Stack>
                      <Box>Замечена подозрительная активность</Box>
                      {/* <Box sx={{ fontSize: '10px' }}>"Нажмите чтобы перейти к фрагменту видео"</Box> */}
                    </Stack>
                  </Stack>
              )}
              {url.slice(-4) === '.bin' ? (
                  <SlidePlayer
                      ref={playerRef}
                      url={url}
                      playing={playing}
                      onPause={()=>setPlaying(false)}
                  />
              ): (
                <ReactPlayer
                    ref={playerRef}
                    controls={false}
                    style={{ ...videoPlayer, ...(flipping?onFlipping:{}) }}
                    width={'100%'} height={'100%'}

                    url={url==='loading' ? [] : [{src: url, type: 'video/mp4'}]}
                    playsinline={true} type='video/mp4'
                    
                    playing={playing}
                    muted={muted}
                    //playbackRate={3}
                    
                    onReady={onReady}
                    onPlay={()=>setPlaying(true)}
                    onPause={()=>setPlaying(false)}
                    onProgress={handleChangeProgress}
                />
              )}

                <PlayButtonArea playing={playing} onClick={handlePlayArea}/>

              {url.slice(-4) !== '.bin' && (
                  <Stack sx={videoControls}>
                      <PlayButton playing={playing} onClick={handlePlay}/>
                      <SeekSlider loadedSeconds={loadedSeconds} playedSeconds={playedSeconds} handleMoveProgress={handleMoveProgress} 
                          start={start/1000} end={end/1000} duration={duration} faceProcessingServiceResult={props?.faceProcessingServiceResult}
                      />
                      <FullScreenButton fullScreen={fullScreen} handle={screenHandle}/>
                  </Stack>
              )}

            </FullScreen>

        </Box>
    )
}